import type { Table } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { DataTable } from '@/components/data-table/data-table';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options';
import { cn } from '@/lib/utils';
import type { PurchaseOrderProduct } from '@/types/core/purchase-order/purchase-order-product';

type PurchaseOrderProductsTableProps = {
  table: Table<PurchaseOrderProduct>;
  isPending: boolean;
  actionBar?: ReactNode;
};

export function PurchaseOrderProductsTable({
  table,
  isPending,
  actionBar,
}: PurchaseOrderProductsTableProps) {
  const hasRows = table.getRowCount() > 0;

  if (isPending && !hasRows) {
    return (
      <DataTableSkeleton className='min-h-0' columnCount={12} rowCount={8} />
    );
  }

  return (
    <div
      className={cn(
        'relative flex min-h-0 flex-1 flex-col',
        isPending && 'pointer-events-none',
      )}
    >
      {isPending && (
        <div className='absolute inset-0 z-20 animate-pulse rounded-md bg-muted/40' />
      )}
      <DataTable
        actionBar={actionBar}
        className={cn('min-h-0', isPending && 'opacity-60')}
        table={table}
      >
        <div
          className='flex w-full items-start justify-end gap-2 p-1'
          role='toolbar'
        >
          <DataTableViewOptions align='end' table={table} />
        </div>
      </DataTable>
    </div>
  );
}
